import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import PageLayout from "../components/layout/PageLayout";
import { LoadingOverlay } from "../components/ui/loading-overlay";
import { fetchWithAuth } from "../Context/UserContext";
import API_URL from "../config";
import { Card, CardContent } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { toast } from "sonner";

const StaffPagosPendientes = () => {
  const [pagos, setPagos] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);
  const [procesando, setProcesando] = useState(null);

  const cargarPagos = async () => {
    setLoading(true);
    try {
      const response = await fetchWithAuth(`${API_URL}/bs/staff/pagos-pendientes`);
      if (response.ok) {
        const data = await response.json();
        setPagos(data.pagos);
      } else {
        const data = await response.json();
        setError(data.error || "No tienes acceso a esta sección.");
      }
    } catch (err) {
      console.error("Error al cargar pagos pendientes:", err);
      setError("Error en la conexión con el servidor.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    cargarPagos();
  }, []);

  const handleAprobar = async (idPayment) => {
    setProcesando(idPayment);
    try {
      const response = await fetchWithAuth(`${API_URL}/bs/staff/pagos-pendientes/${idPayment}/aprobar`, {
        method: "POST",
      });
      if (response.ok) {
        toast.success("Pago aprobado, licitación activada.");
        setPagos((prev) => prev.filter((p) => p.id_payment !== idPayment));
      } else {
        const data = await response.json();
        toast.error(data.error || "No se pudo aprobar el pago.");
      }
    } catch (err) {
      console.error("Error al aprobar pago:", err);
      toast.error("Error en la conexión con el servidor.");
    } finally {
      setProcesando(null);
    }
  };

  const handleRechazar = async (idPayment) => {
    setProcesando(idPayment);
    try {
      const response = await fetchWithAuth(`${API_URL}/bs/staff/pagos-pendientes/${idPayment}/rechazar`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({}),
      });
      if (response.ok) {
        toast.success("Pago rechazado.");
        setPagos((prev) => prev.filter((p) => p.id_payment !== idPayment));
      } else {
        const data = await response.json();
        toast.error(data.error || "No se pudo rechazar el pago.");
      }
    } catch (err) {
      console.error("Error al rechazar pago:", err);
      toast.error("Error en la conexión con el servidor.");
    } finally {
      setProcesando(null);
    }
  };

  if (loading && pagos.length === 0 && !error) {
    return <LoadingOverlay />;
  }

  return (
    <PageLayout>
      <Helmet>
        <title>Pagos pendientes - Procu</title>
      </Helmet>

      <div className="mx-auto max-w-4xl px-4 py-10 sm:px-6">
        <h1 className="text-2xl font-semibold text-foreground">Pagos pendientes de revisión</h1>
        <p className="text-sm text-muted-foreground">Solo visible para el equipo de Procu.</p>

        {error && <p className="mt-6 text-sm text-destructive">{error}</p>}

        <div className="mt-6 space-y-3">
          {pagos.length === 0 && !error && (
            <p className="text-sm text-muted-foreground">No hay comprobantes pendientes de revisión.</p>
          )}
          {pagos.map((pago) => (
            <Card key={pago.id_payment}>
              <CardContent className="space-y-2 pt-6">
                <p className="text-sm font-medium text-foreground">{pago.tender_titulo}</p>
                <p className="text-xs text-muted-foreground">
                  Solicitado por {pago.solicitante_nombre} · {new Date(pago.created_at).toLocaleString()}
                </p>
                <a
                  href={pago.file_path}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-primary hover:underline"
                >
                  Ver comprobante ({pago.file_name})
                </a>
                <div className="flex gap-2 pt-2">
                  <Button
                    size="sm"
                    onClick={() => handleAprobar(pago.id_payment)}
                    disabled={procesando === pago.id_payment}
                  >
                    Aprobar
                  </Button>
                  <Button
                    size="sm"
                    variant="destructive"
                    onClick={() => handleRechazar(pago.id_payment)}
                    disabled={procesando === pago.id_payment}
                  >
                    Rechazar
                  </Button>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </PageLayout>
  );
};

export default StaffPagosPendientes;
